import React from "react";
import Features from "../components/Features";
import Landing from "../components/Landing";
import ShopDiscord from "../components/ShopDiscord";
import Trailer from "../components/Trailer";

function Home() {
  return (
    <>
        <Landing />
        <main>
          <Trailer trailer={true} />
          <Features />
          <ShopDiscord shop={true} />
          <ShopDiscord shop={false} />
          <Trailer trailer={false} />
        </main>
    </>
  );
}

export default Home;
